// src/config.js   (create this file)
export const GOOGLE_GEOCODING_API_KEY = "AIzaSyDU8SoxPLvztJv_uzPw5503xW3blpWUdKo"; // current location
export const GOOGLE_PLACES_API_KEY = "AIzaSyD_BCg5FAIPB0Xd4BtnMngmZ9DAGGVIRCs"; // live fetching places
